import React from "react"
import GlobalHelper from "../../../common/GlobalHelper"
import Icon from "../../../common/icon/icon.component"
import Guard, { Permissions } from "../../../role/Guard"
import { Intl } from "../../../state/helpers/IntlProps"
import {
    FeatureContactExport,
    FeatureProposedQuote,
    FeatureSentInvoiceExport
} from "../../../state/integration/IntegrationFeatureKeys"
import { BULK_OPERATION_TYPE, INTEGRATIONS_SUPPORTING_BULK_EXPORT } from "./constants"
import { BULK_OPERATION_MESSAGES } from "./message"

export const getContactBulkActions = (intl: Intl) => {
    const bulkActions = {
        [BULK_OPERATION_TYPE.CREATE_ACCOUNT_STATEMENT]: <span>
            <Icon value={"file-invoice"} className={"mr-2"}/>
            {intl.formatMessage(BULK_OPERATION_MESSAGES[BULK_OPERATION_TYPE.CREATE_ACCOUNT_STATEMENT])}
        </span>,
        [BULK_OPERATION_TYPE.CONTACT_UPDATE]: <span>
            <Icon value={"edit"} className={"mr-2"}/>
            {intl.formatMessage(BULK_OPERATION_MESSAGES[BULK_OPERATION_TYPE.CONTACT_UPDATE])}
        </span>,
    }

    if (isContactBulkExportSupported()) {
        bulkActions[BULK_OPERATION_TYPE.EXPORT] = <span>
            <Icon value={"file-export"} className={"mr-2"}/>
            {intl.formatMessage(BULK_OPERATION_MESSAGES[BULK_OPERATION_TYPE.EXPORT])}
        </span>
    }

    if (Guard.isAuthorized(Permissions.DeleteInvoice)) {
        bulkActions[BULK_OPERATION_TYPE.DELETE] = <span className={"text-danger"}>
            <Icon value={"trash"} className={"mr-2"}/>
            {intl.formatMessage(BULK_OPERATION_MESSAGES[BULK_OPERATION_TYPE.DELETE])}
        </span>
    }
    return bulkActions
}

export const isContactBulkExportSupported = () => {
    const integrations = GlobalHelper.getIntegrationsWithEnabledFeature(FeatureContactExport)
    return integrations.filter(integration => INTEGRATIONS_SUPPORTING_BULK_EXPORT.includes(integration.attributes.integrationKey)).length > 0
}

export const isQuoteBulkExportSupported = () => {
    const integrations = GlobalHelper.getIntegrationsWithEnabledFeature(FeatureProposedQuote)
    return integrations.filter(integration => INTEGRATIONS_SUPPORTING_BULK_EXPORT.includes(integration.attributes.integrationKey)).length > 0
}


export const isInvoiceBulkExportSupported = () => {
    const integrations = GlobalHelper.getIntegrationsWithEnabledFeature(FeatureSentInvoiceExport)
    return integrations.filter(integration => INTEGRATIONS_SUPPORTING_BULK_EXPORT.includes(integration.attributes.integrationKey)).length > 0
}


// WEBPACK FOOTER //
// ./src/utils/automation/bulk/utils.tsx